<template>
  <div style="margin-top: 20px" class="top-line">
    <Loading :isLoading="saveLoading" />
    <b-modal v-model="paymentTypeModel.show" size="sm" title="选择支付方式">
      <b-row align-v="center">
        <b-col lg="12">
          <b-form-group>
            <b-form-radio v-model="paymentTypeModel.selectedType" name="paymentType" value="fund">
              余额支付(余额:￥{{ paymentTypeModel.memberFund }})</b-form-radio
            >
          </b-form-group>
        </b-col>
      </b-row>
      <template slot="modal-footer">
        <b-button size="sm" variant="success" @click="submitSalesPayment()">支付</b-button>
        <b-button size="sm" variant="danger" @click="paymentTypeModel.show = false">取消</b-button>
      </template>
    </b-modal>
    <b-modal id="payDeposteModel" v-model="payDeposteModel.show" title="会员付款">
      <b-row align-v="center">
        <b-col lg="12" class="registerInfo">
          <b-form>
            <b-form-group label="绑定定单:" label-cols-lg="3" label-align-lg="right" label-size="sm">
              <b-form-input v-model="payDeposteModel.preSaleOrderRecordCode" size="sm" readonly> </b-form-input>
            </b-form-group>
          </b-form>
          <b-form>
            <b-form-group label="总金额:" label-cols-lg="3" label-align-lg="right" label-size="sm">
              <b-form-input v-model="payDeposteModel.preSaleOrderRecordTotalOrderCost" size="sm" readonly>
              </b-form-input>
            </b-form-group>
          </b-form>
          <b-form>
            <b-form-group label="已支付定金:" label-cols-lg="3" label-align-lg="right" label-size="sm">
              <b-form-input
                v-model="payDeposteModel.depositBillRecordDepositPaymentSum"
                size="sm"
                readonly
              ></b-form-input>
            </b-form-group>
          </b-form>
          <!-- <b-form>
						<b-form-group label="折扣:" label-cols-lg="3" label-align-lg="right" label-size="sm">
							<b-form-input v-model="payDeposteModel.discount" size="sm"
								readonly></b-form-input>
						</b-form-group>
					</b-form> -->
          <b-form>
            <b-form-group label="需支付余额:" label-cols-lg="3" label-align-lg="right" label-size="sm">
              <b-form-input v-model="payDeposteModel.remainSum" type="number" size="sm"></b-form-input>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
      <template slot="modal-footer">
        <b-button size="sm" variant="success" @click="submitBookingOrderDeposite()"> 确认支付 </b-button>
        <b-button size="sm" variant="danger" @click="payDeposteModel.show = false"> 取消 </b-button>
      </template>
    </b-modal>
    <div class="d-flex search-wrap">
      <div class="d-flex flex-wrap align-items-center" style="gap: 12px">
        <!-- 输入框区域 -->
        <div class="input-group-container">
          <b-input-group>
            <b-form-input
              size="sm"
              autocomplete="off"
              v-model="depositBillRecordCode"
              placeholder="定单号"
              class="order-input"
            ></b-form-input>
          </b-input-group>
        </div>

        <div class="input-group-container">
          <DatePicker
            type="daterange"
            v-model="selectDates"
            transfer
            placement="bottom-end"
            placeholder="选择定单时间"
            class="search-input"
            @on-change="onDateChange"
          ></DatePicker>
        </div>

        <div class="input-group-container">
          <b-input-group>
            <b-form-input
              size="sm"
              autocomplete="off"
              v-model="operatorName"
              placeholder="经办人账号或姓名"
              class="order-input"
            ></b-form-input>
          </b-input-group>
        </div>

        <div class="input-group-container">
          <b-input-group>
            <b-form-input
              size="sm"
              autocomplete="off"
              v-model="mainCategoryName"
              placeholder="产品大类名称"
              class="order-input"
            ></b-form-input>
          </b-input-group>
        </div>

        <div class="input-group-container">
          <b-input-group>
            <b-form-input
              size="sm"
              autocomplete="off"
              v-model="subCategoryName"
              placeholder="产品小类名称"
              class="order-input"
            ></b-form-input>
          </b-input-group>
        </div>

        <div class="input-group-container">
          <b-input-group>
            <b-form-input
              size="sm"
              autocomplete="off"
              v-model="productName"
              placeholder="产品名称"
              class="order-input"
            ></b-form-input>
          </b-input-group>
        </div>

        <div>
          <RadioGroup v-model="finished" type="button">
            <Radio :label="true">未发货</Radio>
            <Radio :label="false">全部</Radio>
          </RadioGroup>
        </div>

        <!-- 按钮区域 -->
        <div class="button-group">
          <b-button size="sm" v-on:click="onSearch()" variant="success" class="order-button">查询</b-button>
          <b-button size="sm" v-on:click="clearSearch()" variant="outline-secondary" class="order-button"
            >重置</b-button
          >
        </div>
      </div>
    </div>
    <div class="delivery-list">
      <b-table
        id="deposit-table"
        @sort-changed="onDepositBillRecordCreateAtOrderChange"
        :fields="depositBillList.fields"
        :items="depositBillList.depositBillMainVOList"
        small
        bordered
        hover
        show-empty
        empty-text="没有找到匹配的记录"
        :busy="depositBillList.isTableBusy"
        caption-top
      >
        <template slot="table-caption">
          <!-- <span>苗定单列表</span> -->
        </template>
        <template v-slot:cell(depositBillRecordDepositPaymentSum)="data">
          {{ getNumberThousandString(data.value, '0.00') }}
        </template>
        <template v-slot:cell(surplus)="data">
          {{ getNumberThousandString(data.value, '0.00') }}
        </template>
        <template v-slot:cell(totalFee)="data">
          {{ getNumberThousandString(data.value, '0.00') }}
        </template>
        <template v-slot:cell(availableDue)="data">
          {{ getNumberThousandString(data.value, '0.00') }}
        </template>
        <template v-slot:cell(remainingBalance)="data">
          {{ getNumberThousandString(data.value, '0.00') }}
        </template>
        <template v-slot:cell(usedDeposit)="data">
          {{ getNumberThousandString(data.value, '0.00') }}
        </template>
        <div slot="table-busy" class="text-center text-info my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>加载中...</strong>
        </div>
        <template v-slot:cell(depositBillListAction)="row">
          <b-link
            :to="{
              path: '/member/booking-order-detail',
              query: { depositBillRecordUuid: row.item.depositBillRecordUuid }
            }"
            target="_blank"
            >查看</b-link
          >
          <span>
            /
            <a href="#" v-on:click="onSginContract(row)">
              下载种苗定购协议
            </a>
          </span>
        <!-- <span v-if="row.item.paidStatus == '定金已支付'&&row.item.orderStatus!='已生成发货单'&&row.item.surplus>0">
            /
            <a href="#" v-on:click="onPayOrder(row)">支付余额</a>
          </span> -->
        </template>
        <template v-slot:cell(depositBillRecordCreateAt)="row">
          <span>{{ formatDateTimeString(row.item.depositBillRecordCreateAt) }}</span>
        </template>
        <!-- 待付余额 -->
        <!-- <template v-slot:cell(remainingSum)="row">
					<span>{{row.item.mainTotalMoney-row.item.depositBillRecordDepositPaymentSum}}</span>
				</template> -->
      </b-table>
      <div class="pageControl">
        <b-pagination
          v-model="depositBillList.feSearch.limit.conditions.pageStart"
          style="margin-top: 20px"
          :total-rows="depositBillList.feSearch.limit.conditions.total"
          :per-page="depositBillList.feSearch.limit.conditions.pageLength"
          align="center"
          size="sm"
          ellipsis-text="..."
          first-text="首页"
          prev-text="上一页"
          next-text="下一页"
          last-text="尾页"
          limit="10"
          @change="onDepositPageChange"
        ></b-pagination>
      </div>
    </div>

    <PayModal ref="payModal" />
  </div>
</template>

<script>
import Loading from '@/components/loading/Loading.vue'
import api from '@/api/api'
import { formatDateTimeString, numberToFixed, getNumberThousandString } from '@/libs/utils'

import search from '@/libs/search'
import '@/style/global.css'
import PayModal from '../member/pay'
import { param } from 'jquery'
export default {
  name: 'OrderList',
  components: {
    PayModal,
    Loading
  },
  data() {
    return {
      isClick: false,
      api,
      selectDates: [],
      depositBillRecordCode: '',
      operatorName: '',
      productName: '',
      mainCategoryName: '',
      subCategoryName: '',
      operatorType: '',
      depositBillRecordCreateAtOrder: 2,
      finished: true,
      depositBillList: {
        fields: [
          {
            key: 'depositBillRecordCode',
            label: '定金单编号'
          },
          {
            key: 'seedFarmName',
            label: '苗场名称'
          },
          {
            key: 'weekSeq',
            label: '周次'
          },
          {
            key: 'sendProductDate',
            label: '发货日期'
          },
          {
            key: 'receiptFullAddress',
            label: '收货地址'
          },
          {
            key: 'depositBillRecordDepositPaymentSum',
            label: '已付定金'
          },
          {
            key: 'availableDue',
            label: '剩余定金'
          },
          {
            key: 'usedDeposit',
            label: '已用定金'
          },
          {
            key: 'remainingBalance',
            label: '已付余额'
          },
          {
            key: 'surplus',
            label: '待付余额'
          },
          {
            key: 'totalFee',
            label: '产品总额'
          },
          {
            key: 'paidStatus',
            label: '支付状态'
          },
          {
            key: 'shipStatus',
            label: '发货状态'
          },
          // {
          //   key: 'orderStatus',
          //   label: '定单状态'
          // },
          {
            key: 'depositBillRecordCreateAt',
            label: '定单时间',
            sortable: true
          },
          {
            key: 'operatorName',
            label: '经办人'
          },
          {
            key: 'customerMsg',
            label: '客户备注'
          },
          {
            key: 'depositBillListAction',
            label: '操作'
          }
        ],
        keyword: '',
        depositBillMainVOList: [],
        isTableBusy: false,
        feSearch: search.getSearchParams()
      },
      paymentTypeModel: {
        show: false,
        depositValue: 0,
        selectedType: 'fund',
        memberFund: 0
      },
      payDeposteModel: {
        show: false,
        preSaleOrderRecordUuid: '',
        preSaleOrderRecordCode: '',
        preSaleOrderRecordTotalOrderCost: '',
        depositBillRecordDepositPaymentSum: '',
        remainSum: '',
        discount: ''
      },
      depositBillRecordUuidArray: [],
      saveLoading:false
    }
  },
  mounted() {
    if (!this.checkMemberLogin()) {
      this.$router.push({
        name: 'MemberLogin'
      })
      return
    }
    this.depositBillList.feSearch.filters.enable = false
    this.depositBillList.feSearch.filters.conditions = []
    
    this.getUnfinished()
    this.getUserDepositBillInfoList()
    this.getMemberBalance()
  },
  methods: {
    //切换排序
    onDepositBillRecordCreateAtOrderChange() {
      this.depositBillRecordCreateAtOrder = (this.depositBillRecordCreateAtOrder + 1) % 3
      //console.log("this.depositBillRecordCreateAtOrder="+this.depositBillRecordCreateAtOrder);
      this.getUserDepositBillInfoList()
    },
    //排序条件
    setOrderCondition() {
      this.depositBillList.feSearch.order.enable = false
      this.depositBillList.feSearch.order.conditions = []
      if (this.depositBillRecordCreateAtOrder == 1) {
        this.depositBillList.feSearch.order.conditions.push({
          name: 'depositBillRecordCreateAt',
          type: 'asc'
        })
        this.depositBillList.feSearch.order.enable = true
      } else if (this.depositBillRecordCreateAtOrder == 2) {
        this.depositBillList.feSearch.order.conditions.push({
          name: 'depositBillRecordCreateAt',
          type: 'desc'
        })
        this.depositBillList.feSearch.order.enable = true
      } else {
        this.depositBillList.feSearch.order.conditions.push({
          name: 'depositBillRecordCreateAt',
          type: 'desc'
        })
        this.depositBillList.feSearch.order.enable = true
      }
      this.depositBillList.feSearch.order.enable = false   //不用前端的排序条件
    },
    formatDateTimeString,
    numberToFixed,
    getNumberThousandString,
    getMemberBalance() {
      api
        .webGetMemberUserDetail({
          userUuid: this.getLoginCookieUuid()
        })
        .then((res) => {
          if (res.code === 0) {
            this.paymentTypeModel.memberFund = res.data.memberFund
          }
        })
    },
    onDateChange(e) {
      this.selectDates = e
      let field = 'depositBillRecordCreateAt'
      search.globalRemoveFilterConditionKey(this.depositBillList.feSearch, field)
      search.globalResetSearch(this.depositBillList.feSearch)
      this.depositBillList.feSearch.filters.enable = true
      this.depositBillList.feSearch.filters.conditions.push({
        name: field,
        type: 'datebetween',
        value: JSON.stringify(e)
      })
      this.getUserDepositBillInfoList()
    },
    onSearch() {
      if (this.depositBillRecordCode) {
        let field = 'depositBillRecordCode'
        search.globalRemoveFilterConditionKey(this.depositBillList.feSearch, field)
        search.globalResetSearch(this.depositBillList.feSearch)
        this.depositBillList.feSearch.filters.enable = true
        this.depositBillList.feSearch.filters.conditions.push({
          name: field,
          type: 'like',
          value: this.depositBillRecordCode
        })
      }
      if (this.operatorName) {
        let field = 'concat(uers.userPersonName, uers.userName)'
        search.globalRemoveFilterConditionKey(this.depositBillList.feSearch, field)
        search.globalResetSearch(this.depositBillList.feSearch)
        this.depositBillList.feSearch.filters.enable = true
        this.depositBillList.feSearch.filters.conditions.push({
          name: field,
          type: 'like',
          value: this.operatorName
        })
      }
      if (this.mainCategoryName) {
        let field = 'mainCategoryName'
        search.globalRemoveFilterConditionKey(this.depositBillList.feSearch, field)
        search.globalResetSearch(this.depositBillList.feSearch)
        this.depositBillList.feSearch.filters.enable = true
        this.depositBillList.feSearch.filters.conditions.push({
          name: field,
          type: 'like',
          value: this.mainCategoryName
        })
      }
      if (this.subCategoryName) {
        let field = 'subCategoryName'
        search.globalRemoveFilterConditionKey(this.depositBillList.feSearch, field)
        search.globalResetSearch(this.depositBillList.feSearch)
        this.depositBillList.feSearch.filters.enable = true
        this.depositBillList.feSearch.filters.conditions.push({
          name: field,
          type: 'like',
          value: this.subCategoryName
        })
      }
      if (this.productName) {
        let field = 'productName'
        search.globalRemoveFilterConditionKey(this.depositBillList.feSearch, field)
        search.globalResetSearch(this.depositBillList.feSearch)
        this.depositBillList.feSearch.filters.enable = true
        this.depositBillList.feSearch.filters.conditions.push({
          name: field,
          type: 'like',
          value: this.productName
        })
      }
      this.getUnfinished()
      this.getUserDepositBillInfoList()
    },
    getUnfinished(){
      let field = 'finished'
      search.globalRemoveFilterConditionKey(this.depositBillList.feSearch, field)
      search.globalResetSearch(this.depositBillList.feSearch)
      this.depositBillList.feSearch.filters.enable = true
      this.depositBillList.feSearch.filters.conditions.push({
        name: field,
        type: 'eq',
        value: this.finished
      })
    },
    clearSearch() {
      this.selectDates = []
      this.depositBillRecordCode = ''
      this.operatorName = ''
      this.mainCategoryName = ''
      this.subCategoryName = ''
      this.productName = ''
      this.depositBillList.feSearch.filters.enable = false
      this.depositBillList.feSearch.filters.conditions = []
      this.getUserDepositBillInfoList()
    },
    getUserDepositBillInfoList() {
      //获取定金已支付的定金单列表
      this.depositBillList.isTableBusy = true
      this.setOrderCondition()
      api.webGetDepositBillOrderList(this.depositBillList.feSearch).then((res) => {
        // uni.hideLoading();
        this.depositBillList.isTableBusy = false
        if (res.code === 0) {
          if (res.data.depositBillMainVOList.length > 0) {
            this.depositBillList.depositBillMainVOList = res.data.depositBillMainVOList
            this.depositBillList.depositBillMainVOList.forEach((e) => {
              if (e.depositBillRecordOrderStatus == '关闭') {
                e.depositBillRecordPaidStatus = '关闭'
              }
              e.depositBillRecordDepositPaymentSum = this.numberToFixed(e.depositBillRecordDepositPaymentSum, 2)
              // e.surplus = this.numberToFixed(e.totalFee - e.depositBillRecordDepositPaymentSum, 2)
              e.surplus = this.numberToFixed(e.surplus, 2)
              e.remainingBalance=this.numberToFixed(e.remainingBalance , 2)
              e.totalFee = this.numberToFixed(e.totalFee, 2)
            })
            // 获取分页条数
            search.globalSetFilterRecordCount(this.depositBillList.feSearch, res.data.filterRecordCount)
          } else {
            this.depositBillList.depositBillMainVOList = []
          }
        }
      })
    },
    onDepositPageChange(pageNum) {
      search.globalPageOnChange(this.depositBillList.feSearch, pageNum)
      this.getUserDepositBillInfoList()
    },
    onPayOrder(row) {
      this.$bvModal
        .msgBoxConfirm('是否确认支付该定单？', {
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: '是',
          cancelTitle: '否'
        })
        .then((value) => {
          if (value) {
            this.payDeposteModel.preSaleOrderRecordUuid = row.item.depositBillRecordUuid
            this.payDeposteModel.preSaleOrderRecordCode = row.item.depositBillRecordCode
            this.payDeposteModel.preSaleOrderRecordTotalOrderCost = row.item.totalFee
            this.payDeposteModel.depositBillRecordDepositPaymentSum = row.item.depositBillRecordDepositPaymentSum
            this.payDeposteModel.discount =
              (row.item.mainTotalMoney * 1000 +
                row.item.packageFee * 1000 +
                row.item.deliveryFee * 1000 -
                row.item.totalFee * 1000) /
              1000
            // this.payDeposteModel.remainSum = row.item.mainTotalMoney-row.item.depositBillRecordDepositPaymentSum;
            this.payDeposteModel.remainSum =
              (row.item.totalFee * 1000 - row.item.depositBillRecordDepositPaymentSum * 1000) / 1000
            this.payDeposteModel.show = true
          }
        })
    },
    submitBookingOrderDeposite() {
      if (this.isClick) {
        return
      }
      this.isClick = true
      this.saveLoading=true;

      this.depositBillRecordUuidArray=[this.payDeposteModel.preSaleOrderRecordUuid];
      api
        .webPreSaleDepositPayWithFund({
          depositBillRecordUuidArray: this.depositBillRecordUuidArray,
          orderType: 'REMAININGMONEY'
        })
        .then((res) => {
          this.saveLoading=false;
          this.isClick = false
          if (res.code === 0) {
            this.payDeposteModel.show = false
            this.$bvModal.msgBoxOk('支付成功', {
              title: '温馨提示',
              buttonSize: 'sm'
            })
            this.getUserDepositBillInfoList()
          } else {
            if (res.message === '余额不足') {
              this.$refs.payModal.showModal()
            }
          }
        }).catch((error) => {
          this.saveLoading=false;
          console.log(error.message); // 处理失败的情况
     });
    },
    submitSalesPayment() {
      if (this.paymentTypeModel.selectedType === 'fund') {
        if (this.isClick) {
          return
        }
        this.isClick = true
        api.webCurrentSalePayWithFund(this.paymentTypeModel).then((res) => {
          this.isClick = false
          if (res.code === 0) {
            this.paymentTypeModel.show = false
            this.getUserDepositBillInfoList()
          } else {
            if (res.message === '余额不足') {
              this.$refs.payModal.showModal()
            }
          }
        })
      } else {
        this.$bvModal.msgBoxOk('暂不支持该支付方式', {
          title: '提示',
          buttonSize: 'sm'
        })
      }
    },
    onSginContract(row) {
      if(this.depositBillList.isTableBusy == true){
        return;
      }
      this.depositBillList.isTableBusy = true
      api
        .AutoSignContract({
          shoppingType: '预售',
          orderUuid: row.item.depositBillRecordUuid
        })
        .then((res) => {
          this.depositBillList.isTableBusy = false
          if (res.code === 0) {
            window.open(res.data.signResult, '_blank')
          }
        })
    }
  }
}
</script>

<style>
.search-wrap {
  margin-top: 30px;
}

/* 选择下单日期 */
.search-input .ivu-input {
  height: 32px;
  line-height: 32px;
  width: 180px;
  padding: 0px 7px;
  color: #333;
}

.search-input .ivu-input-prefix i,
.ivu-input-suffix i {
  font-size: 22px;
  line-height: 32px;
  color: #808695;
}

.order-input {
  height: 32px;
  line-height: 32px;
  width: 210px;
  padding: 0px 7px;
  color: #333;
}

.order-button {
  height: 32px;
  line-height: 32px;
  width: 50px;
  padding: 0px;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff !important;
  border-color: #28a745 !important;
  background-color: #28a745 !important;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #01b252 !important;
}

.delivery-list {
  margin-top: 20px;
}
.delivery-list th {
  background-color: #efefef;
  height: 40px;
  line-height: 40px;
}
.delivery-list tr {
  text-align: center;
  background: #fafafa;
}
.delivery-list th {
  background: #fafafa;
}
.delivery-list td {
  font-size: 14px;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dbdbdb;
}

/* 表格 */
.dataTable {
  margin-top: 20px;
}

.dataTable th {
  background-color: #efefef;
  height: 32px;
  line-height: 32px;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dbdbdb;
}

.table-bordered td,
.table-bordered th {
  border: 1px solid #dbdbdb;
}

.table-sm td,
.table-sm th {
  padding: 10px 5px;
}

/* 表格操作 */
.table-sm td a {
  color: #00b151;
}

/* 页码 */
.page-link {
  color: #757575 !important;
}

.page-link:hover {
  color: #00b151 !important;
}

.page-item.active .page-link {
  color: #fff !important;
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}

.pagination-sm .page-link {
  padding: 5px 12px !important;
  margin-top: 40px;
}

.page-link:focus {
  box-shadow: none !important;
}

.radio-wrap .custom-control-label {
  padding-top: 0px;
}

.input-group-container {
  flex: 1;
  max-width: 200px;
}

.input-group-container b-form-input,
.input-group-container .search-input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/member/deposit-list.vue